package co.uk.paxes.pinpoint.web

import co.uk.paxes.pinpoint.model.*

/**
 * LEGACY STUB - GameEventManager is no longer used.
 * SharedBoardManager handles all game sync via Firebase.
 * 
 * This stub exists only to allow legacy code in Main.kt to compile.
 * All methods are no-ops that immediately call the callback with success=false.
 */
object GameEventManager {
    
    fun broadcastMove(
        roomId: String,
        playerId: String,
        pin: Pin,
        position: Position,
        playerName: String?,
        moveNumber: Int,
        callback: (Boolean, String?) -> Unit
    ) {
        console.log("⚠️ LEGACY: GameEventManager.broadcastMove called but ignored (using SharedBoardManager)")
        callback(false, "Legacy code - use SharedBoardManager")
    }
    
    fun broadcastUndoMove(
        roomId: String,
        playerId: String,
        position: Position?,
        callback: (Boolean, String?) -> Unit
    ) {
        console.log("⚠️ LEGACY: GameEventManager.broadcastUndoMove called but ignored (using SharedBoardManager)")
        callback(false, "Legacy code - use SharedBoardManager")
    }
    
    fun broadcastGameStateUpdateForAndroid(
        roomId: String,
        playerId: String,
        board: Board,
        players: List<Player>,
        currentPlayerIndex: Int,
        currentHand: List<Pin>,
        gamePhase: String = "PLAYING",
        playerHands: Map<String, List<Pin>>? = null,
        handCount: Int = 0,
        callback: ((Boolean, String?) -> Unit)? = null
    ) {
        console.log("⚠️ LEGACY: GameEventManager.broadcastGameStateUpdateForAndroid called but ignored (using SharedBoardManager)")
        callback?.invoke(false, "Legacy code - use SharedBoardManager")
    }
}

/**
 * LEGACY STUB - UndoMoveEvent is no longer used.
 * This data class exists only to allow legacy code in Main.kt to compile.
 */
data class UndoMoveEvent(
    val playerId: String,
    val position: Position? = null
)
